var _path, _path2, _path3, _path4, _path5, _path6, _path7, _g, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNewEmail = function SvgNewEmail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 240,
    height: 240,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#new_email_svg__a)",
    d: "M120.438 227.023c64.859 0 117.437-5.154 117.437-11.512 0-6.357-52.578-11.511-117.437-11.511C55.578 204 3 209.154 3 215.511c0 6.358 52.579 11.512 117.438 11.512Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    d: "m198.89 72.439 7.118 82.451c.57 6.711-3.528 12.599-9.152 13.077L40.394 181.39c-5.593.489-10.647-4.616-11.186-11.318L22.09 87.611a13.849 13.849 0 0 1 .356-4.617c1.118-4.606 4.515-8.135 8.765-8.45L187.673 61.11c4.241-.366 8.136 2.492 10.078 6.824a14.108 14.108 0 0 1 1.139 4.505Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m198.89 72.439 7.118 82.451c.57 6.711-3.528 12.599-9.152 13.077L40.394 181.39c-5.593.489-10.647-4.616-11.186-11.318L22.09 87.611a13.849 13.849 0 0 1 .356-4.617c1.118-4.606 4.515-8.135 8.765-8.45L187.673 61.11c4.241-.366 8.136 2.492 10.078 6.824a14.108 14.108 0 0 1 1.139 4.505Z",
    opacity: 0.1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    d: "m217.465 121.043-1.111.135.449 3.715 1.111-.134-.449-3.716ZM215.3 103.106l-1.111.134 1.673 13.841 1.11-.134-1.672-13.841ZM205.896 57.693l10.231 84.567c.823 6.874-3.183 13.077-8.919 13.769L46.75 175.442c-5.736.691-11.115-4.373-11.949-11.258l-10.23-84.556a14.582 14.582 0 0 1 .203-4.77c1.017-4.769 4.353-8.48 8.715-9.009l160.459-19.403c4.362-.528 8.511 2.268 10.616 6.661a14.53 14.53 0 0 1 1.332 4.586Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m204.564 53.107-72.78 49.005a26.884 26.884 0 0 1-24.609 2.98l-82.37-30.233c1.017-4.77 4.352-8.481 8.715-9.01l160.458-19.403c4.332-.528 8.481 2.268 10.586 6.661Z",
    opacity: 0.1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    d: "m177.412 71.38-20.907 14.075-6.844 4.617-17.878 12.04a26.778 26.778 0 0 1-24.009 3.193l-.641-.214-10.026-3.681-22.576-8.288-10.555-3.874-11.96-4.393-.863-21.142-1.943-46.98L141.068 13l35.012 26.531.366 9.02.966 22.83Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "m177.412 71.38-20.907 14.075-6.844 4.617-17.878 12.04a26.778 26.778 0 0 1-24.009 3.193l-.641-.214-10.026-3.681-22.576-8.288-10.555-3.874-11.96-4.393-.863-21.142-1.943-46.98L141.068 13l35.012 26.531.366 9.02.966 22.83Z",
    opacity: 0.7
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.468 48.877 62.777 53.005a2.176 2.176 0 0 1-2.258-2.034 2.176 2.176 0 0 1 2.034-2.247l101.691-4.129a2.174 2.174 0 0 1 2.257 2.034 2.164 2.164 0 0 1-2.033 2.248ZM165.006 62.391 63.315 66.52a2.176 2.176 0 0 1-2.258-2.034 2.186 2.186 0 0 1 2.034-2.258L164.782 58.1a2.186 2.186 0 0 1 2.258 2.033 2.198 2.198 0 0 1-2.034 2.258ZM165.555 75.896l-101.69 4.129a2.176 2.176 0 0 1-2.258-2.034 2.166 2.166 0 0 1 2.034-2.248l101.691-4.128a2.164 2.164 0 0 1 2.247 2.034 2.168 2.168 0 0 1-2.024 2.247ZM156.505 85.455l-6.844 4.617-75.129 3.05-10.555-3.874c.087-.01.176-.01.264 0l92.264-3.793ZM128.672 102.285v.081a2.174 2.174 0 0 1-2.033 2.176l-18.824.763-.64-.214-10.027-3.681 29.318-1.2a2.175 2.175 0 0 1 2.206 2.075Z"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "m176.121 39.531-24.324-1.047L141.109 13l35.012 26.531Z",
    opacity: 0.1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#51C394",
    d: "m176.121 39.531-23.602-4.037L141.109 13l35.012 26.531Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F65050",
    d: "M216.13 64.21c7.167-6.58 7.642-17.726 1.061-24.892-6.582-7.167-17.726-7.642-24.893-1.061-7.167 6.58-7.642 17.726-1.061 24.893 6.581 7.167 17.726 7.641 24.893 1.06Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M207.71 42.729v17.748h-4.899v-11.62a15.134 15.134 0 0 1-2.307 1.468 18.85 18.85 0 0 1-2.792 1.065v-3.964a11.743 11.743 0 0 0 3.845-1.917 7.925 7.925 0 0 0 2.142-2.757l4.011-.023Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "new_email_svg__a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 11.5114 -117.438 0 120.438 215.511)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2CCD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F7F7F7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6FAFC",
    stopOpacity: 0
  })))));
};
export default SvgNewEmail;